import { useState } from "react";

// Components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Card, CardContent, CircularProgress, Divider, FormControlLabel, Switch, Typography } from "@mui/material";
import UserDocumentRow from "./DocumentRow/DocumentRow";

// Icons
import TopicIcon from "@mui/icons-material/Topic";

// Services
import UserService from "../../../../services/UserService";

const UserLegalDocuments = ({ items, user, refreshData }) => {
  const [isDocVerified, setIsDocVerified] = useState(user?.doc_authorizated || false);
  const [isDocVerifiedLoading, setIsDocVerifiedLoading] = useState(false);

  const handleDocVerifiedChange = async () => {
    setIsDocVerifiedLoading(true);
    try {
      await UserService.toggleStatus(user?.id, "doc_authorizated");
      setIsDocVerified(!isDocVerified);
    } catch (e) {
      console.error(e);
    } finally {
      setIsDocVerifiedLoading(false);
    }
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="h6" sx={{ display: "flex", gap: 1 }}>
            <TopicIcon /> Documents légaux
          </Typography>
          <FormControlLabel
            control={<Switch defaultChecked />}
            checked={isDocVerified}
            label={
              isDocVerifiedLoading ? (
                <CircularProgress size={20} />
              ) : isDocVerified ? (
                <Typography variant="body2" sx={{ fontWeight: 500, color: "text.secondary" }}>
                  Documents vérifiés
                </Typography>
              ) : (
                <Typography variant="body2" sx={{ fontWeight: 500, color: "text.secondary" }}>
                  Documents non vérifiés
                </Typography>
              )
            }
            labelPlacement="start"
            onChange={handleDocVerifiedChange}
            disabled={isDocVerifiedLoading}
          />
        </Box>
        <Divider sx={{ mb: 2 }} />
        <TableContainer component={Paper} sx={{ width: "100%" }}>
          <Table aria-label="simple table" size="small">
            <TableHead>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>Date d'envoi</TableCell>
                <TableCell>Date d'expiration</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((row) => (
                <UserDocumentRow row={row} refreshDocuments={refreshData} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default UserLegalDocuments;
